import { LogRoutes } from "./LogRoutes";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSMenuActionProps } from "namirasoft-site-react";

export class LogMenus
{
	static showLogs(props: NSARouterMakerResult, getIDs: () => string[]): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Show Logs",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: () =>
				{
					let id = getIDs()[0];
					props.url.redirect(LogRoutes.LogList(id), {});
				},
				showLoading: false
			}
		}
	}
}